import { normalize, schema } from "normalizr";

export const normalizeBlockListArray = (originalSubscription) => {
  const authorSchema = new schema.Entity("authors");
  const blockListSchema = new schema.Entity("blocklist", {
    author: authorSchema,
  });

  const blockList = new schema.Array(blockListSchema);

  return normalize(originalSubscription, blockList);
};
